<template>
  <div class="d-flex align-center">
    <v-btn
      v-if="showBtn"
      color="red"
      data-test="upgrade_workspace_category_button"
      elevation="0"
      dark
      :loading="loading"
      @click="getUpgradeLink">
      {{ btnText }}
    </v-btn>
  </div>
</template>
<script>
import {
  mapGetters, mapState,
} from 'vuex';
import WorkspacePaymentsApi from '@/services/graphql/workspacePayment';

export default {
  name: 'AppHeaderLayoutUpgradeBtn',
  props: {
    userId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      reqId: 0,
      btnText: 'My Plan',
      loading: false,
    };
  },
  computed: {
    ...mapGetters('Workspace', [
      'getActiveWorkspaceOwner',
      'getActiveWorkspaceType',
      'isPersonalWorkspace',
    ]),
    ...mapState('Workspace', ['activeWorkspaceId']),
    showBtn() {
      return this.getActiveWorkspaceOwner?.id === this.userId && !this.isPersonalWorkspace;
    },
  },
  watch: {
    activeWorkspaceId() {
      this.fetchWSSubData();
    },
    getActiveWorkspaceType() {
      this.fetchWSSubData();
    },
  },
  mounted() {
    this.fetchWSSubData();
  },
  methods: {
    getUpgradeLink() {
      this.$router.push({
        name: 'workspace-payment',
        params: {
          wId: this.activeWorkspaceId,
        },
      });
    },
    async fetchWSSubData() {
      this.loading = true;
      this.btnText = 'My Plan';
      const id = ++this.reqId;
      try {
        const { data } = await WorkspacePaymentsApi.getWorkspaceSubscription({
          workspaceId: this.activeWorkspaceId,
        });
        if (id !== this.reqId) return;

        const subs = data?.response ?? [];
        if (!subs.length || subs.length < 1) return;

        subs.sort((a, b) => new Date(b.subEnd) - new Date(a.subEnd));
        const latest = subs[0];

        const subEnd = new Date(latest.subEnd);
        const now = new Date();

        if (now < subEnd && latest.status === 'trialing') {
          const diffMs = subEnd - now;
          const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
          if (diffDays >= 1) {
            this.btnText = `${diffDays} day${diffDays > 1 ? 's' : ''} remaining`;
          } else {
            const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
            this.btnText = `${diffHours} hour${diffHours !== 1 ? 's' : ''} remaining`;
          }
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
